import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Navbar
    nav_services: 'Services',
    nav_products: 'Produits',
    nav_testimonials: 'Témoignages',
    nav_faq: 'FAQ',
    nav_contact: 'Contact',
    nav_cta: 'Contactez-nous',
    
    // Hero
    hero_badge: 'SOLUTIONS DIGITALES',
    hero_title_1: 'Construisez vos applications.',
    hero_title_2: 'Gardez le contrôle.',
    hero_subtitle: 'Nous transformons vos idées en solutions digitales complètes, modernes et évolutives.',
    hero_cta_1: 'Demander un devis',
    hero_cta_2: 'Demander une démo',
    
    // Services
    services_badge: 'NOS SERVICES',
    services_title: 'Ce que nous construisons',
    services_cta: 'Demander un devis',
    services_applications: 'Applications',
    services_websites: 'Sites Web',
    services_automation: 'Automatisation & IA',
    services_mobile: 'Applications Mobiles',
    services_mobile_desc: 'Nous développons des applications mobiles modernes.',
    services_web_apps: 'Applications Web',
    services_web_apps_desc: 'Dashboards interactifs et systèmes de gestion.',
    services_saas: 'SaaS',
    services_saas_desc: 'Solutions logicielles en tant que service.',
    services_showcase: 'Site Vitrine',
    services_showcase_desc: 'Présentation professionnelle de votre entreprise.',
    services_platform: 'Plateforme Web',
    services_platform_desc: 'Systèmes complets et personnalisés.',
    services_landing: 'Landing Page',
    services_landing_desc: 'Pages de conversion marketing.',
    services_automation_title: 'Automatisation',
    services_automation_desc: 'Automatisez vos processus métier.',
    services_ai: 'Intelligence Artificielle',
    services_ai_desc: 'Solutions IA personnalisées.',
    services_connections: 'Connexions',
    services_connections_desc: 'Connectez vos outils entre eux.',
    
    // Stats
    stats_projects: 'Projets réalisés',
    stats_clients: 'Clients satisfaits',
    stats_experience: 'Années d\'expérience',
    stats_support: 'Support 24/7',
    
    // Control
    control_badge: 'CONTRÔLE TOTAL',
    control_title: 'Vous gardez le contrôle total de votre solution',
    control_subtitle: 'Nous développons vos solutions en vous donnant toutes les clés. Code source, données, hébergement - tout vous appartient.',
    control_access: 'Accès complet',
    control_access_desc: 'Vous êtes propriétaire de votre code et de vos données.',
    control_users: 'Gestion utilisateurs',
    control_users_desc: 'Gérez vos utilisateurs et leurs permissions en toute autonomie.',
    control_scale: 'Évolutivité',
    control_scale_desc: 'Vos solutions grandissent avec votre entreprise.',
    control_independence: 'Indépendance',
    control_independence_desc: 'Aucune dépendance à long terme. Vous êtes libre.',
    
    // Idea
    idea_title_1: 'Vous avez une idée ?',
    idea_title_2: 'Nous construisons tout le reste.',
    idea_subtitle: 'Même sans structure, nous analysons votre idée, proposons plusieurs solutions et développons celle que vous choisissez.',
    idea_form_title: 'Partagez votre idée',
    idea_submit: 'Envoyer mon idée',
    idea_success: 'Merci ! Nous vous contacterons bientôt.',
    
    // Products
    products_badge: 'NOS PRODUITS',
    products_title: 'Applications JoSmart',
    products_features: 'Fonctionnalités',
    products_download: 'Télécharger',
    products_more: 'En savoir plus',
    products_available: 'Disponible',
    products_coming_soon: 'Bientôt disponible',
    products_in_preparation: 'En préparation',
    
    // Testimonials
    testimonials_badge: 'TÉMOIGNAGES',
    testimonials_title: 'Ce que nos clients disent',
    testimonials_subtitle: 'Découvrez les retours de nos clients satisfaits',
    testimonials_add: 'Laisser un témoignage',
    testimonials_form_title: 'Votre témoignage',
    testimonials_name: 'Votre nom',
    testimonials_company: 'Entreprise (optionnel)',
    testimonials_role: 'Poste (optionnel)',
    testimonials_message: 'Votre témoignage',
    testimonials_rating: 'Note',
    testimonials_submit: 'Envoyer',
    testimonials_success: 'Merci ! Votre témoignage sera publié après validation.',
    testimonials_empty: 'Soyez le premier à laisser un témoignage !',
    
    // FAQ
    faq_badge: 'FAQ',
    faq_title: 'Questions fréquentes',
    faq_subtitle: 'Trouvez les réponses à vos questions',
    
    // Contact
    contact_badge: 'CONTACT',
    contact_title: 'Contactez-nous',
    contact_subtitle: 'Pour toute question, suggestion ou demande de partenariat, n\'hésitez pas à nous contacter.',
    contact_methods: 'Moyens de contact',
    contact_form_title: 'Envoyez-nous un message',
    contact_success: 'Message envoyé avec succès !',
    contact_success_sub: 'Nous vous répondrons bientôt.',
    
    // Forms
    form_name: 'Nom',
    form_email: 'Email',
    form_message: 'Message',
    form_submit: 'Envoyer',
    form_sending: 'Envoi en cours...',
    form_error: 'Une erreur est survenue. Veuillez réessayer.',
    form_project_type: 'Type de projet',
    form_budget: 'Budget (optionnel)',
    form_product: 'Produit concerné',
    form_subject: 'Sujet',
    form_describe_idea: 'Décrivez votre idée',
    form_select: 'Sélectionnez...',
    form_mobile_app: 'Application mobile',
    form_website: 'Site web',
    form_saas: 'SaaS',
    form_other: 'Autre',
    form_information: 'Information',
    form_partnership: 'Partenariat',
    form_support: 'Support',
    
    // Footer
    footer_desc: 'Construire des applications intelligentes pour la communication, l\'éducation et le futur numérique.',
    footer_navigation: 'Navigation',
    footer_contact: 'Contact',
    footer_social: 'Réseaux sociaux',
    footer_privacy: 'Politique de confidentialité',
    footer_rights: 'Tous droits réservés.',
    footer_payment: 'Paiement',
    footer_social_coming: 'Bientôt disponible',
    footer_jobs: 'Emplois',
    
    // Misc
    whatsapp: 'WhatsApp',
    email: 'Email',
    back_to_site: 'Retour au site',
    see_more: 'Voir plus',
    close: 'Fermer',
  },
  en: {
    // Navbar
    nav_services: 'Services',
    nav_products: 'Products',
    nav_testimonials: 'Testimonials',
    nav_faq: 'FAQ',
    nav_contact: 'Contact',
    nav_cta: 'Contact us',
    
    // Hero
    hero_badge: 'DIGITAL SOLUTIONS',
    hero_title_1: 'Build your applications.',
    hero_title_2: 'Keep control.',
    hero_subtitle: 'We transform your ideas into complete, modern and scalable digital solutions.',
    hero_cta_1: 'Request a quote',
    hero_cta_2: 'Request a demo',
    
    // Services
    services_badge: 'OUR SERVICES',
    services_title: 'What we build',
    services_cta: 'Request a quote',
    services_applications: 'Applications',
    services_websites: 'Websites',
    services_automation: 'Automation & AI',
    services_mobile: 'Mobile Applications',
    services_mobile_desc: 'We develop modern mobile applications.',
    services_web_apps: 'Web Applications',
    services_web_apps_desc: 'Interactive dashboards and management systems.',
    services_saas: 'SaaS',
    services_saas_desc: 'Software as a service solutions.',
    services_showcase: 'Showcase Website',
    services_showcase_desc: 'Professional presentation of your company.',
    services_platform: 'Web Platform',
    services_platform_desc: 'Complete and customized systems.',
    services_landing: 'Landing Page',
    services_landing_desc: 'Marketing conversion pages.',
    services_automation_title: 'Automation',
    services_automation_desc: 'Automate your business processes.',
    services_ai: 'Artificial Intelligence',
    services_ai_desc: 'Custom AI solutions.',
    services_connections: 'Connections',
    services_connections_desc: 'Connect your tools together.',
    
    // Stats
    stats_projects: 'Projects completed',
    stats_clients: 'Satisfied clients',
    stats_experience: 'Years of experience',
    stats_support: '24/7 Support',
    
    // Control
    control_badge: 'TOTAL CONTROL',
    control_title: 'You keep total control of your solution',
    control_subtitle: 'We develop your solutions by giving you all the keys. Source code, data, hosting - everything belongs to you.',
    control_access: 'Full access',
    control_access_desc: 'You own your code and data.',
    control_users: 'User management',
    control_users_desc: 'Manage your users and their permissions autonomously.',
    control_scale: 'Scalability',
    control_scale_desc: 'Your solutions grow with your business.',
    control_independence: 'Independence',
    control_independence_desc: 'No long-term dependency. You are free.',
    
    // Idea
    idea_title_1: 'Have an idea?',
    idea_title_2: 'We build everything else.',
    idea_subtitle: 'Even without structure, we analyze your idea, propose several solutions and develop the one you choose.',
    idea_form_title: 'Share your idea',
    idea_submit: 'Send my idea',
    idea_success: 'Thank you! We will contact you soon.',
    
    // Products
    products_badge: 'OUR PRODUCTS',
    products_title: 'JoSmart Applications',
    products_features: 'Features',
    products_download: 'Download',
    products_more: 'Learn more',
    products_available: 'Available',
    products_coming_soon: 'Coming soon',
    products_in_preparation: 'In preparation',
    
    // Testimonials
    testimonials_badge: 'TESTIMONIALS',
    testimonials_title: 'What our clients say',
    testimonials_subtitle: 'Discover feedback from our satisfied clients',
    testimonials_add: 'Leave a testimonial',
    testimonials_form_title: 'Your testimonial',
    testimonials_name: 'Your name',
    testimonials_company: 'Company (optional)',
    testimonials_role: 'Position (optional)',
    testimonials_message: 'Your testimonial',
    testimonials_rating: 'Rating',
    testimonials_submit: 'Submit',
    testimonials_success: 'Thank you! Your testimonial will be published after validation.',
    testimonials_empty: 'Be the first to leave a testimonial!',
    
    // FAQ
    faq_badge: 'FAQ',
    faq_title: 'Frequently Asked Questions',
    faq_subtitle: 'Find answers to your questions',
    
    // Contact
    contact_badge: 'CONTACT',
    contact_title: 'Contact us',
    contact_subtitle: 'For any question, suggestion or partnership request, feel free to contact us.',
    contact_methods: 'Contact methods',
    contact_form_title: 'Send us a message',
    contact_success: 'Message sent successfully!',
    contact_success_sub: 'We will respond soon.',
    
    // Forms
    form_name: 'Name',
    form_email: 'Email',
    form_message: 'Message',
    form_submit: 'Send',
    form_sending: 'Sending...',
    form_error: 'An error occurred. Please try again.',
    form_project_type: 'Project type',
    form_budget: 'Budget (optional)',
    form_product: 'Related product',
    form_subject: 'Subject',
    form_describe_idea: 'Describe your idea',
    form_select: 'Select...',
    form_mobile_app: 'Mobile application',
    form_website: 'Website',
    form_saas: 'SaaS',
    form_other: 'Other',
    form_information: 'Information',
    form_partnership: 'Partnership',
    form_support: 'Support',
    
    // Footer
    footer_desc: 'Building intelligent applications for communication, education and the digital future.',
    footer_navigation: 'Navigation',
    footer_contact: 'Contact',
    footer_social: 'Social networks',
    footer_privacy: 'Privacy policy',
    footer_rights: 'All rights reserved.',
    footer_payment: 'Payment',
    footer_social_coming: 'Coming soon',
    footer_jobs: 'Jobs',
    
    // Misc
    whatsapp: 'WhatsApp',
    email: 'Email',
    back_to_site: 'Back to site',
    see_more: 'See more',
    close: 'Close',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('josmart-language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('josmart-language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
